import { Box, Typography } from "@mui/material";

const bars = [0, 1, 2, 3];

const LogoAnimated = () => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        animation: "fadeScaleIn 0.8s ease forwards",
        "@keyframes fadeScaleIn": {
          from: { opacity: 0, transform: "scale(0.95)" },
          to: { opacity: 1, transform: "scale(1)" },
        },
      }}
    >
      {/* ICON CHART */}
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-end",
          gap: "4px",
          height: 40,
        }}
      >
        {bars.map((b) => (
          <Box
            key={b}
            sx={{
              width: 6,
              height: 10,
              backgroundColor: "#122D4B",
              borderRadius: 1,
              animation: "barMove 1.2s ease-in-out infinite",
              animationDelay: `${b * 0.15}s`,
              "@keyframes barMove": {
                "0%": { height: 10 },
                "50%": { height: 36 },
                "100%": { height: 10 },
              },
            }}
          />
        ))}
      </Box>

      {/* TEXT LOGO */}
      <Typography
        variant="h3"
        sx={{
          fontWeight: 700,
          color: "#122D4B",
          letterSpacing: 0.5,
        }}
      >
        Portal<span style={{ fontWeight: 800 }}>Data</span>
      </Typography>
    </Box>
  );
};

export default LogoAnimated;
